<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center wrap>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title class="headline pb-2">
              <v-layout wrap>
                <v-flex xs12>
                  {{ getTitle(protocol) }}
                </v-flex>
                <v-flex xs12 pt-2 v-if="$isSuperuser()">
                  <PublishedChip :value="protocol" />
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <table>
                <tr>
                  <th class="text-xs-left pr-4">Datum</th>
                  <td>{{ protocol.date | toLocaleDateString }}</td>
                </tr>
                <tr v-if="$isSuperuser()">
                  <th class="text-xs-left pr-4">Veröffentlicht per</th>
                  <td>
                    {{ protocol.publishing_datetime | toLocaleDateTimeString }}
                  </td>
                </tr>
                <tr v-if="$isSuperuser()">
                  <th v-if="protocol.protocol_id" class="text-xs-left pr-4">
                    <router-link :to="{ name: 'session', id: protocol.id }">
                      Session
                    </router-link>
                  </th>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions v-if="$isSuperuser()">
              <v-btn
                @click="$showNotificationDialog"
                depressed
              >Benachrichtigen</v-btn>
              <v-btn
                :to="{ name: 'edit-protocol', type: $route.params.type, id: $route.params.id }"
                depressed
              >Bearbeiten</v-btn>
              <v-btn
                @click="destroy"
                color="red"
                depressed
                dark
              >Löschen</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Session from '@/models/session';
import Protocol from '@/models/protocol';
import { confirmedDestroy } from '@/helpers/utils';

export default {
  name: 'EditProtocol',
  async initialAsyncData({ id, type }) {
    if (type === 'session') {
      await Session.findOrFetch(id);
    } else {
      await Protocol.findOrFetch(id);
    }
  },
  data() {
    const isSession = this.$route.params.type === 'session';
    const { id } = this.$route.params;
    const protocol = isSession ? Session.find(id) : Protocol.find(id);
    return {
      protocol,
      isSession,
    };
  },
  methods: {
    getTitle(protocol) {
      return `Grossratsprotokoll vom ${this.$options.filters.toLocaleDateString(protocol.date)}`;
    },
    async destroy() {
      if (this.isSession) {
        this.protocol.protocol_id = null;
        await confirmedDestroy(this.protocol, (session) => {
          session.update(['protocol_id']);
        });
      } else {
        await confirmedDestroy(this.protocol);
      }

      return this.$router.push({ name: 'protocols' });
    },
  },
};
</script>
